import { onInstallService } from './handlers/install'

// TODO - Split what is widtget, what is config slack
export const SLACK_WIDGET = {
  id: 'SLACK_INTEGRATION',
  type: 'OAUTH',
  name: 'Integração com Slack',
  description: 'Criar integração com o Slack',
  color: 'lightPurple',
  image: '/services/slack.png',
  categories: ['Comunicação'],
  service: 'slack',
  onClick: onInstallService,
  initialState: {
    name: 'Comunicação',
    data: {}
  }
}
